import { render, staticRenderFns } from "./ListAuditoriaMotivoView.vue?vue&type=template&id=1634cfd7&"
import script from "./ListAuditoriaMotivoView.vue?vue&type=script&lang=ts&"
export * from "./ListAuditoriaMotivoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports